import { TenantActivationScreen } from "@src/features/patriot-tools";

export default TenantActivationScreen;
